import { ApiKeypair, DataKeypair, getPublicApiKey, getPublicDataKey, getSecretApiKey, getSecretDataKey, PublicApiKey, PublicDataKey, SecretApiKey, SecretDataKey } from "./types/keys";
import { UnexpectedValueError } from "./unexpected-value-error";
import { AwsAuthInputConfig } from "@aws-sdk/middleware-signing";
import { RegionInputConfig } from "@aws-sdk/config-resolver";

export async function getServerPublicDataKey(): Promise<PublicDataKey> {
  const raw = getPublicDataKey();
  return UnexpectedValueError.throwIfNot("env.PUBLIC_DATA_KEY",
    PublicDataKey, raw);
}

export async function getServerSecretDataKey(): Promise<SecretDataKey> {
  const raw = getSecretDataKey();
  return UnexpectedValueError.throwIfNot("env.SECRET_DATA_KEY",
    SecretDataKey, raw);
}

export async function getServerDataKeypair(): Promise<DataKeypair> {
  return {
    publicKey: await getServerPublicDataKey(),
    secretKey: await getServerSecretDataKey(),
  };
}

export async function getServerPublicApiKey(): Promise<PublicApiKey> {
  const raw = getPublicApiKey();
  return UnexpectedValueError.throwIfNot("env.NEXT_PUBLIC_API_KEY",
    PublicApiKey, raw);
}

export async function getServerSecretApiKey(): Promise<SecretApiKey> {
  const raw = getSecretApiKey();
  return UnexpectedValueError.throwIfNot("env.SECRET_API_KEY",
    SecretApiKey, raw);
}

export async function getServerApiKeypair(): Promise<ApiKeypair> {
  return {
    publicKey: await getServerPublicApiKey(),
    secretKey: await getServerSecretApiKey(),
  };
}

export type AwsConfiguration =
  AwsAuthInputConfig & { region: NonNullable<RegionInputConfig['region']> };

export function getAwsConfiguration(): AwsConfiguration | undefined {
  if (process.env.CLIENT_AWS_ACCESS_KEY_ID
    && process.env.CLIENT_AWS_SECRET_ACCESS_KEY
    && process.env.CLIENT_AWS_REGION) {
    return {
      credentials: {
        accessKeyId: process.env.CLIENT_AWS_ACCESS_KEY_ID,
        secretAccessKey: process.env.CLIENT_AWS_SECRET_ACCESS_KEY,
      },
      region: process.env.CLIENT_AWS_REGION,
    };
  }

  return undefined;
}
